import React from 'react'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import * as routes from 'core/routing/constants/index'
import { withRouter } from 'react-router-dom'
import wizardsShape from 'core/components/wizard/shapes'
import _ from 'lodash'
import { Col } from 'core/components/ui'
import CardVehicle from 'core/layouts/card-vehicle'
import { modelShape, configuratorShape } from '../../shapes'

const ModelItem = props => {
  const { setWizards, wizards, history, setConfigurator, configurator, model } = props

  const modelSelected = configurator.model

  const isSelected = modelSelected && modelSelected.id === model.id

  const activateNextStep = () => {
    const aStepsActive = wizards[wizards.activeWizard]
    const nextIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_MODELS) + 1

    const extendedStep = { ...aStepsActive[nextIndex], isActive: true }

    const extendedSteps = Object.assign([...aStepsActive], {
      [nextIndex]: extendedStep
    })
    const extentedWizards = { ...wizards, aStepsConfigurator: extendedSteps }
    setWizards(extentedWizards)

    history.push(extendedStep.hash)
  }

  const desactivateNextSteps = () => {
    const aStepsActive = wizards[wizards.activeWizard]

    const currentIndex = aStepsActive.findIndex(step => step.hash === routes.CONFIGURATOR_MODELS)

    const steps = aStepsActive.map((step, index) => {
      let returnedStep = step
      if (index > currentIndex) returnedStep = { ...step, isActive: false }

      return returnedStep
    })

    const extentedWizards = { ...wizards, aStepsConfigurator: steps }

    setWizards(extentedWizards)
  }

  const handleClick = async () => {
    const { urlImage, price } = model

    const finishes = _.isEqual(model, configurator.model) ? configurator.finishes : null
    const finishesList = _.isEqual(model, configurator.model) ? configurator.finishesList : null
    if (!_.isEqual(model, configurator.model)) await desactivateNextSteps()

    const extentedConfigurator = { ...configurator, model, finishesList, finishes, urlImage, price }

    setConfigurator(extentedConfigurator)
    activateNextStep()
  }

  return (
    <Col
      lg={5}
      md={10}
      sm={20}
      xs={24}
      onClick={() => handleClick(model)}
      data-test="component-configurator-model-item"
    >
      <CardVehicle selected={isSelected} vehicle={model} />
    </Col>
  )
}

ModelItem.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  setWizards: PropTypes.func.isRequired,
  wizards: wizardsShape.isRequired,
  model: modelShape.isRequired,
  setConfigurator: PropTypes.func.isRequired,
  configurator: configuratorShape.isRequired
}

export default withRouter(ModelItem)
